import React from 'react';
import { motion } from 'framer-motion';
import { FaLaptopCode, FaHardHat, FaUniversity } from 'react-icons/fa';
import SectionHeader from './_primitives/SectionHeader';

const CATEGORIES = [
  {
    icon:   <FaLaptopCode className="text-3xl text-brand-purple" />,
    label:  'White Collar',
    bg:     'from-secondary-50 to-white',
    border: 'border-secondary-200',
    roles:  ['Software Engineer', 'Sales', 'Designer', 'Finance', 'HR', 'Operations'],
    cta:    'Explore professional jobs →',
  },
  {
    icon:   <FaHardHat className="text-3xl text-brand-saffron" />,
    label:  'Blue Collar',
    bg:     'from-orange-50 to-white',
    border: 'border-orange-200',
    roles:  ['Delivery', 'Driver', 'Electrician', 'Cook', 'Security', 'Cleaner'],
    cta:    'Explore skilled jobs →',
  },
  {
    icon:   <FaUniversity className="text-3xl text-brand-green" />,
    label:  'Government',
    bg:     'from-green-50 to-white',
    border: 'border-green-200',
    roles:  ['Railway Jobs', 'SSC', 'Banking', 'State PSC', 'Defence', 'Teaching'],
    cta:    'Explore govt jobs →',
  },
];

export default function CategoryCards({ onStartSearching }) {
  return (
    <section className="py-14 md:py-24 px-4 sm:px-6 bg-paper">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          eyebrow="For every kind of work"
          title={<>Built for all of <span className="text-brand-saffron">Bharat</span></>}
          subtitle="Whether you work in tech, on the ground, or for the government — we've got you covered."
        />
        <div className="grid md:grid-cols-3 gap-6">
          {CATEGORIES.map((cat, i) => (
            <motion.div
              key={cat.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className={`rounded-3xl border ${cat.border} bg-gradient-to-b ${cat.bg}
                          p-8 flex flex-col gap-6 hover:shadow-glass-lg
                          hover:-translate-y-1 transition-all duration-300`}
            >
              <div className="w-14 h-14 rounded-2xl bg-white border border-gray-100
                              flex items-center justify-center shadow-sm">
                {cat.icon}
              </div>
              <div>
                <h3 className="font-display font-black text-2xl text-ink-900 mb-1">
                  {cat.label}
                </h3>
                <div className="flex flex-wrap gap-2 mt-3">
                  {cat.roles.map(r => (
                    <span key={r}
                          className="px-2.5 py-0.5 rounded-full text-xs font-semibold
                                     bg-white border border-gray-200 text-ink-500">
                      {r}
                    </span>
                  ))}
                </div>
              </div>
              <button
                onClick={onStartSearching}
                className="mt-auto text-sm font-bold text-ink-900 hover:text-brand-purple
                           transition-colors text-left"
              >
                {cat.cta}
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
